/**
 * @generated SignedSource<<3d6e3767bf118be9b6e228e00773d1cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MicrophoneRecording_getSignedUploadMutation$variables = {
  fileExtension: string;
  meetingRecordingId: string;
};
export type MicrophoneRecording_getSignedUploadMutation$data = {
  readonly getSignedUploadForClientSideMeetingRecording: {
    readonly fields: any;
    readonly uploadUrl: string;
  } | null;
};
export type MicrophoneRecording_getSignedUploadMutation = {
  response: MicrophoneRecording_getSignedUploadMutation$data;
  variables: MicrophoneRecording_getSignedUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileExtension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fileExtension",
        "variableName": "fileExtension"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "GetSignedUploadForClientSideMeetingRecording",
    "kind": "LinkedField",
    "name": "getSignedUploadForClientSideMeetingRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fields",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrophoneRecording_getSignedUploadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MicrophoneRecording_getSignedUploadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "681534f1a1d566bac3c681b695a21ef6",
    "id": null,
    "metadata": {},
    "name": "MicrophoneRecording_getSignedUploadMutation",
    "operationKind": "mutation",
    "text": "mutation MicrophoneRecording_getSignedUploadMutation(\n  $meetingRecordingId: ID!\n  $fileExtension: String!\n) {\n  getSignedUploadForClientSideMeetingRecording(meetingRecordingId: $meetingRecordingId, fileExtension: $fileExtension) {\n    uploadUrl\n    fields\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5eddf637678dc0eadf008ed8227fc58";

export default node;
